import {
  MetadataInspectionError,
  type MetadataInspection,
  type MetadataInspectionErrorCode,
} from './metadataInspection'

interface WorkerResponse {
  id: number
  result?: MetadataInspection
  error?: MetadataInspectionErrorCode
}

let requestId = 0

export function inspectPhotoMetadata(
  bytes: ArrayBuffer,
  signal: AbortSignal,
): Promise<MetadataInspection> {
  return new Promise((resolve, reject) => {
    if (signal.aborted) {
      reject(new DOMException('Aborted', 'AbortError'))
      return
    }
    const id = ++requestId
    const worker = new Worker(
      new URL('../worker/metadata.worker.ts', import.meta.url),
      { type: 'module' },
    )
    const cleanup = () => {
      signal.removeEventListener('abort', abort)
      worker.terminate()
    }
    const abort = () => {
      cleanup()
      reject(new DOMException('Aborted', 'AbortError'))
    }
    signal.addEventListener('abort', abort, { once: true })
    worker.onerror = () => {
      cleanup()
      reject(new MetadataInspectionError('processing_failed'))
    }
    worker.onmessage = (event: MessageEvent<WorkerResponse>) => {
      if (event.data.id !== id) return
      cleanup()
      if (event.data.result) {
        resolve(event.data.result)
      } else {
        reject(new MetadataInspectionError(event.data.error ?? 'processing_failed'))
      }
    }
    worker.postMessage({ id, bytes }, [bytes])
  })
}
